import {connect} from 'react-redux';
import Capacity from './Capacity.jsx';

import {
  setSquadCapacity,
  hideCapacityDialog
} from './actionTypes';

import {
  handleUpdateButtonClick,
  handleUpdateSquadCapacity,
  handleUpdateSquadVisibility
} from './actions';

const mapStateToProps = state => state.tournament.capacity;

const mapDispatchToProps = dispatch => ({
  onUpdateClick: () => dispatch(handleUpdateButtonClick()),
  onModalCloseClick: () => dispatch(hideCapacityDialog()),
  onSquadCapacityBlur: data => dispatch(handleUpdateSquadCapacity(data)),
  onSquadCapacityChange: (id, value) => dispatch(setSquadCapacity(id, value)),
  onSquadVisibilityChange: (id, value) => dispatch(handleUpdateSquadVisibility(id, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(Capacity);



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/CapacityContainer.jsx